<template>
  <ts-loading-banner :loading="waiting">
    <div class="tw-space-y-4">
      <div class="row">
        <div class="col-12 tw-space-y-1">
          <label class="required">{{ $t("subjectProfile.subjectCode") }}</label>
          <input
            v-model.trim="model.subject_code"
            type="text"
            class="form-control"
            :class="{ 'is-invalid': errors.has('subject_code') }"
            :placeholder="$t('subjectProfile.subjectCode')"
          />
          <div class="invalid-feedback" v-if="errors.has('subject_code')">
            {{ errors.first("subject_code") }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 tw-space-y-1">
          <label class="required">{{ $t("subjectProfile.nameKH") }}</label>
          <input
            v-model.trim="model.subject_name_kh"
            type="text"
            class="form-control"
            :class="{ 'is-invalid': errors.has('subject_name_kh') }"
            :placeholder="$t('subjectProfile.nameKH')"
          />
          <div class="invalid-feedback" v-if="errors.has('subject_name_kh')">
            {{ errors.first("subject_name_kh") }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 tw-space-y-1">
          <label class="required">{{ $t("subjectProfile.nameEN") }}</label>
          <input
            v-model.trim="model.subject_name_en"
            type="text"
            class="form-control"
            :class="{ 'is-invalid': errors.has('subject_name_en') }"
            :placeholder="$t('subjectProfile.nameEN')"
          />
          <div class="invalid-feedback" v-if="errors.has('subject_name_en')">
            {{ errors.first("subject_name_en") }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 tw-flex tw-justify-end tw-space-x-3">
          <ts-button class="mr-2" @click.prevent="() => $emit('cancel')">
            {{ $t("cancel") }}
          </ts-button>
          <ts-button
            v-if="!isUpdate"
            color="primary"
            outline
            :waiting="waiting"
            :disabled="waiting"
            @click.prevent="onSaveAddNew"
          >
            {{ $t("saveAddNew") }}</ts-button
          >
          <ts-button
            v-if="!isUpdate"
            :waiting="waiting"
            :disabled="waiting"
            color="primary"
            @click.prevent="onSave"
            >{{ $t("save") }}</ts-button
          >
          <ts-button
            v-if="isUpdate"
            :waiting="waiting"
            :disabled="waiting"
            color="primary"
            @click.prevent="onUpdate"
            >{{ $t("update") }}</ts-button
          >
        </div>
      </div>
    </div>
  </ts-loading-banner>
</template>

<script>
import { isEmpty } from "lodash";
import { Errors } from "form-backend-validation";
import { mapState } from "vuex";
export default {
  name: "subjectForm",
  data() {
    return {
      waiting: false,
      errors: new Errors(),
      showBrowseFileBotton: false,
      model: {
        subject_profile_id: null,
        subject_code: null,
        subject_name_kh: null,
        subject_name_en: null,
      },
    };
  },
  computed: {
    ...mapState("academic/subjectProfile", ["edit_data"]),
    isUpdate() {
      return !isEmpty(this.edit_data);
    },
  },
  created() {
    this.setEditData();
  },
  methods: {
    async onSave() {
      this.waiting = true;
      this.$store
        .dispatch("academic/subjectProfile/store", this.model)
        .then(async (response) => {
          this.$notify({ type: "success", text: response.message });
          this.$emit("fetchData");
          this.$emit("cancel");
        })
        .catch((error) => {
          this.$notify({ type: "error", text: error.message });
          this.errors = new Errors(error.errors);
        })
        .finally(() => {
          this.waiting = false;
        });
    },
    async onSaveAddNew() {
      this.errors = new Errors();
      this.waiting = true;
      this.$store
        .dispatch(
          "academic/subjectProfile/store",
          Object.assign({}, this.model)
        )
        .then(async (response) => {
          this.$notify({
            type: "success",
            text: response.message,
          });
          this.clearEdit();
        })
        .catch((error) => {
          this.errors = new Errors(error.errors);
          this.$notify({ type: "error", text: error.message });
        })
        .finally(() => {
          this.waiting = false;
        });
    },
    async onUpdate() {
      this.waiting = true;
      this.$store
        .dispatch("academic/subjectProfile/update", {
          id: this.model.subject_profile_id,
          data: this.model,
        })
        .then(async (response) => {
          this.$notify({ type: "success", text: response.message });
          this.$emit("cancel");
        })
        .catch((error) => {
          this.$notify({ type: "error", text: error.message });
          this.errors = new Errors(error.errors);
        })
        .finally(() => {
          this.waiting = false;
        });
    },
    clearEdit() {
      this.model.subject_profile_id = null;
      this.model.subject_code = null;
      this.model.subject_name_kh = null;
      this.model.subject_name_en = null;
    },
    setEditData() {
      if (!isEmpty(this.edit_data)) {
        this.model.subject_profile_id = this.edit_data.subject_profile_id;
        this.model.subject_code = this.edit_data.subject_code;
        this.model.subject_name_kh = this.edit_data.subject_name_kh;
        this.model.subject_name_en = this.edit_data.subject_name_en;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>